import { render } from "./org-root.vue?vue&type=template&id=4818ee92"
import script from "./org-root.vue?vue&type=script&lang=js"
export * from "./org-root.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__